import { AppHttpClient } from 'common/core/http/app-http-client.service';
import { CurrentUser } from 'common/auth/current-user';
import * as i0 from "@angular/core";
import * as i1 from "../../common/core/http/app-http-client.service";
import * as i2 from "../../common/auth/current-user";
var DriveEntryApiService = /** @class */ (function () {
    function DriveEntryApiService(http, currentUser) {
        this.http = http;
        this.currentUser = currentUser;
    }
    DriveEntryApiService.prototype.getEntriesForFolder = function (params) {
        if (params === void 0) { params = {}; }
        return this.http.get('drive/entries', params);
    };
    DriveEntryApiService.prototype.getCurrentUserEntries = function (params) {
        params.userId = this.currentUser.get('id');
        return this.http.get('drive/entries', params);
    };
    DriveEntryApiService.prototype.update = function (entryId, params) {
        return this.http.put('uploads/' + entryId, params);
    };
    DriveEntryApiService.prototype.delete = function (params) {
        return this.http.delete('drive/entries', params);
    };
    DriveEntryApiService.prototype.copy = function (params) {
        return this.http.post('drive/entries/copy', params);
    };
    DriveEntryApiService.prototype.restore = function (params) {
        return this.http.post('drive/entries/restore', params);
    };
    DriveEntryApiService.prototype.emptyTrash = function () {
        return this.delete({ emptyTrash: true });
    };
    DriveEntryApiService.prototype.moveEntries = function (params) {
        if (params.destination === 'root')
            params.destination = null;
        return this.http.post('drive/entries/move', params);
    };
    DriveEntryApiService.prototype.addStar = function (ids) {
        return this.http.post('drive/entries/star', { ids: ids });
    };
    DriveEntryApiService.prototype.removeStar = function (ids) {
        return this.http.post('drive/entries/unstar', { ids: ids });
    };
    DriveEntryApiService.prototype.getSpaceUsage = function () {
        return this.http.get('drive/user/space-usage');
    };
    DriveEntryApiService.ngInjectableDef = i0.defineInjectable({ factory: function DriveEntryApiService_Factory() { return new DriveEntryApiService(i0.inject(i1.AppHttpClient), i0.inject(i2.CurrentUser)); }, token: DriveEntryApiService, providedIn: "root" });
    return DriveEntryApiService;
}());
export { DriveEntryApiService };
